import './teams.module';
import './teams.config';
import './$teams.factory';

import './components';
import './services';
